'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = decorate;

var _applyLegacyPropertyDecorator = require('nanotools/lib/applyLegacyPropertyDecorator');

var _applyLegacyPropertyDecorator2 = _interopRequireDefault(_applyLegacyPropertyDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function decorate(constr, definitions) {
	var proto, k, v;
	proto = constr.prototype;
	for (k in definitions) {
		v = definitions[k];
		if (Array.isArray(v)) {
			v.forEach(function (x) {
				return (0, _applyLegacyPropertyDecorator2.default)(proto, k, x);
			});
		} else {
			(0, _applyLegacyPropertyDecorator2.default)(proto, k, v);
		}
	}
}